import { Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, inject, Input, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BreakpointService } from '../../../../../services/breakpoints';
import { ButtonComponent } from '../../../atoms';
import { ToggleCardComponent } from '../../../molecules';
import { COOKIE_OPTIONS } from '../constants/cookie-options.constant';
import { CookiePreferences } from '../models/cookie-preferences.model';

@Component({
  selector: 'app-cookie-settings-modal',
  templateUrl: './cookie-settings-modal.component.html',
  styleUrls: ['./cookie-settings-modal.component.scss'],
  standalone: true,
  imports: [ToggleCardComponent, ButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieSettingsModalComponent {
  private readonly breakpointService = inject(BreakpointService);
  private readonly activeModal = inject(NgbActiveModal);

  protected readonly options = COOKIE_OPTIONS;

  protected readonly preferencesState = signal<CookiePreferences>({ all: false });

  @Input() set savedPreferences(value: CookiePreferences | null) {
    if (value) this.preferencesState.set(value);
    else this.preferencesState.set(this.getDefaultPreferences());
  }

  protected readonly isMobile = toSignal(
    this.breakpointService.isMatchingBreakpoint(Breakpoints.Handset),
    { initialValue: false },
  );

  protected onToggled(key: keyof CookiePreferences, value: boolean): void {
    this.preferencesState.update((state) => ({
      ...state,
      [key]: value,
    }));
  }

  protected onSave(): void {
    this.activeModal.close(this.preferencesState());
  }

  private getDefaultPreferences(): CookiePreferences {
    return this.options.reduce<CookiePreferences>(
      (acc, item) => {
        if (item.configName) acc[item.configName] = item.defaultValue;
        return acc;
      },
      { all: false },
    );
  }
}
